import React, { useState, useEffect } from 'react';
import { ExpenseCategory } from '../../pages';
import { toJS } from 'mobx';

import { ExpenseCategoryController } from '../../controllers';
import { expenseCategoryStore } from '../../stores';

const ExpenseCategoryContainer = () => {
    const [loading, setLoading] = useState(false);
    const [addExpCategoryModal, setAddExpCategoryModal] = useState(false);
    const [editExpCategoryModal, setEditExpCategoryModal] = useState(false);
    const [deleteExpCategoryModal, setDeleteExpCategoryModal] = useState(false);

    useEffect(() => {
        setLoading(true)
        const getExpenseCategorydetails = async () => {
            await ExpenseCategoryController.getExpenseCategories();
            setLoading(false);
        }
        getExpenseCategorydetails();
    }, [])

    const goToAddExpCategoryModal = () => {
        setAddExpCategoryModal(true);
    }
    const goToEditExpCategoryModal = () => {
        setEditExpCategoryModal(true);
    }
    const goToDeleteExpCategoryModal = () => {
        setDeleteExpCategoryModal(true);
    }

    const closeModal = () => {
        setAddExpCategoryModal(false);
        setEditExpCategoryModal(false);
        setDeleteExpCategoryModal(false);
    }

    return (
        <ExpenseCategory
            goToDeleteExpCategoryModal={goToDeleteExpCategoryModal}
            deleteExpCategoryModal={deleteExpCategoryModal}
            goToAddExpCategoryModal={goToAddExpCategoryModal}
            addExpCategoryModal={addExpCategoryModal}
            goToEditExpCategoryModal={goToEditExpCategoryModal}
            editExpCategoryModal={editExpCategoryModal}
            loading={loading}
            closeModal={closeModal}
            expenseCategoryList={toJS(expenseCategoryStore.expenseCategory)}
        />
    )
}
export default ExpenseCategoryContainer;